import { toast } from '@/hooks/use-toast'

export async function handleShare({
  title,
  text,
  url = window.location.origin,
}: {
  title: string
  text: string
  url?: string
}) {
  if (navigator.share) {
    try {
      await navigator.share({
        title: title,
        text: text,
        url: url,
      })
      console.log('Shared successfully')
    } catch (error) {
      // console.error('Error sharing:', error)
    }
  } else {
    toast({
      title: 'Feature Not Supported',
      description: 'Web Share API is not supported in your browser.',
    })
  }
}
